// We are not using enums anymore because they made the code more complex
// without adding extra checks. We migrated to direct use of strings
// This file is left here just as reference

export const Enums = {

  LinesAlignment: [ 'Left', 'Center', 'Right' ],

  FillMode: [ 'CadX', 'Alternate', 'Winding' ],

  BrushTransformMode: [ 'Fixed', 'Clamp', 'RotateOnly', 'Full', 'StretchX', 'StretchY' ],

  DashStyle: [ 'Solid', 'Dash', 'Dot', 'DashDot', 'DashDotDot' ],

  LineCap: [ 'Flat', 'Square', 'Round', 'Triangle' ],

  DashCap: [ 'Flat', 'Round', 'Triangle' ],

  LineJoin: [ 'Miter', 'Bevel', 'Round', 'MiterClipped', 'AdaptiveMiter' ],

  CurveType: [ 'Bezier3', 'Polyline' ],

  FitOnPathHPos: [ 'Fixed_Left', 'Fixed_CenterTop', 'Fixed_CenterBottom', 'Fixed_Right',
                   'Stretched', 'Scaled', 'Expanded' ],

  FitOnPathVPos: [
    'Above', // Figures are placed such that the bottom side of its bounding box aligns with the path
    'Over',  // Figures are placed such that the baseline of its bounding box aligns with the path
    'Below'  // Figures are placed such that the top side of its bounding box aligns with the path
  ],

  FitEllipseFit: [
    'None',      // The text is kept with its current kerning
    'Scaled',    // Each letter is scaled to fit into the target range
    'Contained', // If the text exceeds the target range, each letter is scaled down.
    'Stretched', // The kerning is recalculated so the text fits into the target range
                 // keeping the size of letters.
    'Expanded'   // If the text exceeds the target range, the range is scaled up to
                 // fit them.
  ],

  FitEnvelopeHPos: [ 'Left', 'Center', 'Right', 'Stretched', 'Expanded' ],

  FitEnvelopeVPos: [ 'Top', 'Center', 'Bottom', 'Stretched', 'Expanded' ],

  FitEnvelopeMode: [ 'Freeform', 'Mixed', 'Uniform', 'Boxed' ],

  Effect3DLightSource: [ 'Up', 'Right', 'Down', 'Left' ],

  HAlignment: [ 'Left', 'Center', 'Right' ],

  VAlignment: [ 'Baseline', 'Top', 'Middle', 'Bottom' ],

  CornerType: [ 'Mittered', 'Chamfered', 'Rounded' ],

  HalftoneType: ['Full', 'Circle', 'Ellipse'],
  
  ReshapeAction: [ 'Combine', 'Weld', 'FrontMinusBack', 'BackMinusFront', 'Condense',
                   'BreakApart', 'BreakApartRegions', 'BreakApartByColor' ],

  VerticalStyle: [ 'SingleLine', 'MultiLine' ],

  ColorType: ['RGB','CMYK','CE','LAB','GRAY']
};

export default Enums;



/** WEBPACK FOOTER **
 ** ./src/cdl/enums.js
 **/